import React from 'react'
import { Link } from 'react-router-dom';
import constants from '../../../../constants/constants';
import ResourceList from '../ResourceList/ResourceList';

const PodcastList = () => {
	const newCrumb = [<Link key={1} to="/podcast-list" className="!text-black font-semibold">Podcasts</Link>];
	const beforeUpload = (file) => {
		const isMP3 = file.type === 'audio/mpeg' || file.name.toLowerCase().endsWith('.mp3');

		if (!isMP3) {
			success('error', `${file.name} is not an MP3 file`, 'flashSuccess', messageApi);
			return false;
		}

		return true;
	};
	return (
		<ResourceList
			title="PODCAST LIST"
			fetchUrl="/get-podcast-list-admin"
			uploadUrl="/upload-podcast"
			breadcrumbs={newCrumb}
			resourceType={3}
			uploadSuccessMsg={constants.podcast_upload_success}
			uploadErrorMsg={constants.podcast_upload_failure}
			selectSuccessMsg={constants.podcast_select_success}
			acceptFileType="audio/mpeg"
			beforeUpload={beforeUpload}
		/>
	);
}

export default PodcastList